import { css } from '@eti/styles';
export const rowItemSize = css`
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;
export const seatButtonStyles = css`
  ${rowItemSize};
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  outline: 0;
  padding: 0;
  position: relative;
  text-align: left;

  html[dir='rtl'] & {
    text-align: right;
  }

  svg {
    height: 100%;
    width: 100%;
  }
`;
//# sourceMappingURL=styles.js.map